import PropTypes from 'prop-types';
import React from 'react';
import CopyToClipboard from 'react-copy-to-clipboard';
import {Label} from 'semantic-ui-react';

const ClickableLabel = ({name, value, size}) =>
	value !== undefined && value !== null ? (
		<CopyToClipboard
			text={value}
			style={{cursor: 'pointer'}}
			data-tip="Click to copy"
		>
			<Label size={size} basic>
				{name}
				<Label.Detail>{value}</Label.Detail>
			</Label>
		</CopyToClipboard>
	) : null;

ClickableLabel.defaultProps = {
	size: 'medium'
};

ClickableLabel.propTypes = {
	name: PropTypes.string.isRequired,
	value: PropTypes.any.isRequired,
	size: PropTypes.string
};

export default ClickableLabel;
